// extracted by mini-css-extract-plugin
export var component = "intro-module--component--2vRMD";
export var title = "intro-module--title--1HgJE";
export var content = "intro-module--content--2ieXN";
export var background = "intro-module--background--y358r";